import { useEffect, useState } from "react";
import { getAllBookings} from "../../../http/bookingAPI";
import { IBookingResponseModel } from "../../../interfaces/responses/IBookingResponseModel";
import moment from "moment";

const BookingManage: React.FC = () => {
    const [bookings, setBookings] = useState<IBookingResponseModel[]>([]);
    const [error, setError] = useState<string | null>(null);
    const [filteredBookings, setFilteredBookings] = useState<IBookingResponseModel[]>([]);
    const [searchId, setSearchId] = useState<string>('');
    const [filterType, setFilterType] = useState<'current' | 'past'>('current');

    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setSearchId(value);
        
        if (value) {
            setFilteredBookings(bookings.filter(booking => booking.id.toString().includes(value)));
        } else {
            setFilteredBookings(bookings);
        }
    };
    
    const filterBookings = (searchValue: string, filter: 'current' | 'past') => {
        let filtered = bookings;
        const currentDate = moment();
        
        if (filter === 'current') {
            filtered = bookings.filter(booking => moment(booking.event_date).isAfter(currentDate));
        } else if (filter === 'past') {
            filtered = bookings.filter(booking => moment(booking.event_date).isBefore(currentDate));
        }
        
        if (searchValue) {
            filtered = filtered.filter(booking => booking.id.toString().startsWith(searchValue));
        }
        
        setFilteredBookings(filtered);
    };
    
    const handleFilterChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const value = e.target.value as 'current' | 'past';
        setFilterType(value);
        filterBookings(searchId, value);
    };
    
    const fetchBookings = async () => {
        const result = await getAllBookings();
        if (Array.isArray(result)) {
            const currentDate = moment();
            const initialFilteredBookings = result.filter(booking =>
                filterType === 'current'
                    ? moment(booking.event_date).isAfter(currentDate)
                    : moment(booking.event_date).isBefore(currentDate)
            );
            
            setBookings(result);
            setFilteredBookings(initialFilteredBookings);
        } else {
            setError('Ошибка при получении бронирований');
        }
    };
    
    useEffect(() => {
        fetchBookings();
    }, []);
    
    return (
        <div className="manage_container">
            <div className="manage_filters">
                <input
                    type="number"
                    placeholder="Поиск по ID бронирования"
                    value={searchId}
                    onChange={handleSearchChange}
                    className="search_input"
                />
                <select value={filterType} onChange={handleFilterChange} className="filter_select">
                    <option value="current">Текущие мероприятия</option>
                    <option value="past">Прошедшие мероприятия</option>
                </select>
            </div>
            {error ? (
                <div>{error}</div>
            ) : (
                <table className='event_table'>
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Email гостя</th>
                            <th>Событие</th>
                            <th>Дата события</th>
                            <th>Тип билета</th>
                            <th>Количество</th>
                            <th>Сумма</th>
                            <th>Дата создания</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredBookings.map(booking => (
                            <tr key={booking.id}>
                                <td>{booking.id}</td>
                                <td>{booking.user_email}</td>
                                <td>{booking.event_name}</td>
                                <td>{moment(booking.event_date).format('DD.MM.YY HH:mm')}</td>
                                <td>{booking.ticket_type}</td>
                                <td>{booking.quantity} шт.</td>
                                <td>{booking.total_price} ₽</td>
                                <td>{moment(booking.createdAt).format('DD.MM.YY HH:mm')}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
};

export default BookingManage;